<template>
  <div class="login_wrapper">
    <Login class="login-container" />
    <!-- <LoginMobile class="login-mobile-container" /> -->
    <LoginIpad class="login-iPad-container"/>
  </div>
</template>

<script>
import Login from "./Login.vue";
import LoginMobile from "./LoginMobile.vue";
import LoginIpad from './LoginIpad.vue'
export default {
  name: "LoginContainer",
  components: {
    Login,
    LoginMobile,
    LoginIpad
  },
};
</script>

<style lang="scss">
.login-container{
  height: 700px;
  max-width:984px;
  &.row{
	  margin: 0px auto;
  }
  @media (min-width:1387px) and (min-height:850px){
     height: 830px !important;
     max-width: 1347px !important;
  }
  
  @media all and (max-width: 768px) and (max-height: 1024px) and (orientation:portrait) {
     display: none !important; 
  }
  @media all and (max-width: 1024px) and (max-height: 1367px) and (orientation:portrait) {
    display: none !important; 
  }
  @media (max-width: 767px){
    display: none !important;
  }
}
.login-iPad-container{
  display: none;
  @media all and (max-width: 768px) and (max-height: 1024px) and (orientation:portrait) {
     display: flex !important;
     justify-content: center; 
  }
  @media all and (max-width: 1024px) and (max-height: 1367px) and (orientation:portrait) {
    display: flex !important; 
    justify-content: center; 
  }
}
// .login-mobile-container {
//   display: none;
//   @media (max-width: 767px) {
//     display: flex !important;
//   }
//   // @media all and (device-width: 768px) and (device-height: 1024px) and (orientation:portrait) {
//   //    display: none !important; 
//   // }
// }
// .login-container{
//   height: 700px;
// //   max-width:984px;
//   @media all and (max-width:1024px){
//     display: none !important;
//   }
// }
// .login-iPad-container{
//   display: none;
//   @media all and (max-width:1024px) and (orientation:portrait) {
//     display: flex !important;
//   }
// }
// .login-mobile-container{
//   display: none;
//   @media all and (max-width:480px) {
//     display: flex;
//   }
// }
</style>
